<div class="loader-container" *ngIf="!dataBookingLoaded || !dataFlightLoaded || !copyLoaded">
  <div class="loader">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</div>

<div *ngIf="dataBookingLoaded && dataFlightLoaded && copyLoaded">
  <div [ngSwitch]="step">
    <div *ngSwitchCase="0">
      <app-get-flyback-details
        [bookingReference]='bookingReference'
        [flightDirection]='flightDirection'
        [flightData]='this.flightData'
        [copyLoaded]='copyLoaded'
        [appCopy]='appCopy'
        [appAirportCopy]='appAirportCopy'
        [selectedLanguage]='selectedLanguage'
        [languageCode]='languageCode'
      ></app-get-flyback-details>
    </div>
    <div *ngSwitchCase="1">
      <app-get-flyback-flight-results
        [showFlyBackSection]='showFlyBackSection'
        [bookingReference]='bookingReference'
        [flightDirection]='flightDirection'
        [flightData]='this.flightData'
        [copyLoaded]='copyLoaded'
        [appCopy]='appCopy'
        [appAirportCopy]='appAirportCopy'
        [selectedLanguage]='selectedLanguage'
        [languageCode]='languageCode'></app-get-flyback-flight-results>
    </div>
    <div *ngSwitchCase="2">
      <app-flyback-flight-confirmation
        [showFlyBackSection]='showFlyBackSection'
        [flightData]='this.flightData'
        [copyLoaded]='copyLoaded'
        [appCopy]='appCopy'
        [appAirportCopy]='appAirportCopy'
        [selectedLanguage]='selectedLanguage'
        [languageCode]='languageCode'></app-flyback-flight-confirmation>
    </div>
  </div>
</div>
<app-page-loader></app-page-loader>
